<template>

   <div class="card">
      <div class="card-body m-2">
         <div class="row">
            <!-- for block details -->
            <div class="col-2">
               <br><br>
               <div class="card">
                  <BlockFormEdit ref="blockEditRef" />
               </div>
            </div>
            <div class="col-6 collapse-transition" :style="{ width: isCollapsed ? '1200px' : null }">
               <br><br>
               <div class="card">
                  <div>
                     <div class="row">
                        <div class="col-8 d-flex align-items-end text-start">
                           <h4 class=" modal-title"><strong>Content Block</strong></h4>
                        </div>
                        <div class="col-4 d-row d-flex flex-row-reverse align-items-end position-bottom">
                           <div class="block-button-container">
                              <button v-if="$store.getters['auth/canEditContentLibrary']" type="button"
                                 class="btn btn-outline-info btn-circle ms-1" title="Click to Save"
                                 @click="$event.stopPropagation(); this.saveContent()">
                                 <i class="fa-solid fa-check"></i>
                               </button>

                              <button type="button"
                                 class="btn btn-outline-info btn-circle ms-1" :title="isCollapsed ? 'Click to Collapse' : 'Click to Expand'"
                                 @click="isCollapsed = !isCollapsed">
                                 <i :class="[{'fa-solid fa-minimize': isCollapsed, 'fa-solid fa-expand': !isCollapsed}]"></i>
                              </button>
                           </div>
                        </div>
                     </div>
                     <hr />
                  </div>
                  <div class="row">
                     <WysiwygEditor :apiKey="tiny_mce_api_key" :css_code="css_code" @component-loaded="renderContent()"
                        ref="editorRef">
                     </WysiwygEditor>
                  </div>
               </div>
            </div>
            <div class="col-4 collapsible-content" :style="{ width: isCollapsed ? '0px' : null }">
               <br><br>
               <div class="card" :style="{visibility: isCollapsed ? 'hidden' : 'visible'}">
                  <BlockVariableFields ref="blockVariableFieldsRef" />
               </div>
               <div style="clear: both;"></div>
            </div>
         </div>
      </div>
   </div>

</template>

<script>
import moment from 'moment'
import { truncateLongText } from '@/plugins/helper.js'
import WysiwygEditor from '@/components/Utilities/WysiwygEditor.vue'
import BlockFormEdit from '@/components/ContentLibrary/BlockFormEdit.vue'
import BlockVariableFields from '@/components/ContentLibrary/BlockVariableFields.vue'

export default ({
   components: {
      WysiwygEditor,
      BlockFormEdit,
      BlockVariableFields,
   },

   props: {
      id: {
         type: String,
      },
      organisationId: {
         // type: String,
      },
      block_type: {
         type: String
      }
   },

   data() {
      return {
         currentBlockType: null,
         blockData: { /* Your block data here */ }, // Data to pass to your blocks
         componentToRender: {

         },
         isLoading: false,
         tiny_mce_api_key: "",
         css_code: "",
         isCollapsed: false,
      }
   },

   created() {
      this.tiny_mce_api_key = process.env.VUE_APP_TINY_MCE_API_KEY
      this.css_code = `
      
         .image-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            /* Responsive columns */
            grid-gap: 10px;
            /* Spacing between grid items */
         }

         .grid-item {
            overflow: hidden;
            border: 3px solid black; /* Add a border to each grid item */
            /* Prevents image overflow */
         }

         .grid-item img {
            width: 100%;
            height: auto;
            display: block;
            /* Prevents image from creating extra space */
         }

         body { 
            font-family:"Roboto",sans-serif; 
            font-size:16px 
         }

          .testimonial-container {
            display: flex;
            flex-direction: column; /* Stack elements vertically */
            align-items: center; /* Center horizontally */
            font-family: sans-serif;
    border: 1px solid #ddd;
    padding: 20px;
    width: 300px; /* Reduced width */
    text-align: center; /* Center text */
    margin-bottom: 20px; /* Add some space below each testimonial */
    position: relative;
}

.testimonial-avatar {
    width: 70px; /* Avatar size */
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 15px; /* Space below avatar */
}

.testimonial-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.testimonial-text {
    font-size: 16px;
    line-height: 1.4;
    margin-bottom: 10px;
}

.testimonial-author {
    font-weight: bold;
    font-size: 14px;
    margin-top: 0;
}

.testimonial-title {
    font-size: 12px;
    color: #00A0C1;
}

/* New CSS for the remove button */
.remove-testimonial-button {
    position: absolute;
    top: 5px; /* Distance from the top */
    right: 5px; /* Distance from the right */
    background-color: #ff4d4d; /* Red background for "remove" */
    color: white;
    border: none;
    border-radius: 50%; /* Make it circular */
    width: 25px; /* Size of the button */
    height: 25px; /* Size of the button */
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    display: flex; /* Use flexbox to center 'X' */
    justify-content: center;
    align-items: center;
    padding: 0; /* Remove default padding */
    line-height: 1; /* Prevent extra line height issues for 'X' */
    z-index: 10; /* Ensure it's above other content */
    box-shadow: 0 2px 4px rgba(0,0,0,0.2); /* Optional shadow */
    transition: background-color 0.2s ease; /* Smooth hover effect */
}

.remove-testimonial-button:hover {
    background-color: orange; /* Darker red on hover */
}

mark {
   background-color: transparent !important;
   color: inherit !important;
}
         `
   },

   mounted() {
      this.init()
   },

   computed: {
      item() {
         return this.id
      },
   },

   watch: {
      // item() {
      //    this.init()
      // },
   },

   methods: {

      addContent(content) {
         this.$refs.editorRef.addContent(content)
      },

      setContent(content, isDisabled) {
         this.$refs.editorRef.setContent(content, isDisabled)
      },

      setHeaderTitle(title) {
         this.$parent.title = title
      },

      getContent(content) {
         return this.$refs.editorRef.getContent(content)
      },

      setToDisabled() {
         this.$refs.editorRef.setToDisabled()
      },

      saveContent() {
         this.$refs.blockEditRef.updateBlock()
      },

      switchBlockType(blockType) {
         this.currentBlockType = blockType;
      },

      toggleBold() {
         this.isBold = !this.isBold;
      },
      toggleItalic() {
         this.isItalic = !this.isItalic;
      },
      toggleUnderline() {
         this.isUnderline = !this.isUnderline;
      },

      init() {
         this.$refs.blockEditRef.editBlock(this.id)
      },

      renderContent() {
         this.$refs.blockEditRef.triggerDebounce()
      },

      formatDate(date) {
         return moment(date).format("DD-MMM-YYYY")
      },

      truncateLongText(text, limit) {
         return truncateLongText(text, limit)
      },

      onSubmit() {

      },

      checkIfIDExist(id_string) {
         return this.$refs.editorRef.checkIfIDExist(id_string)
      },

      addTestimonialToGrid(testimonial, html) {
         this.$refs.editorRef.addTestimonialToGrid(testimonial, html)
      },
   }
})

</script>
<style scoped>
.audit-menu-tab {
   border: none;
   /* margin: 1rem; */
}

.audit-menu-tab .nav-link {
   color: #435666;
   height: 40px;
   width: 200px;
   min-width: 95px;
   /* padding: 1rem; */
   font-weight: 400;
   border: 1px solid #A3C0D1;
}

button.nav-link {
   border-radius: 0px !important;
}

.audit-menu-tab .nav-link.active {
   background-color: #00A0C1;
   color: #fff;
   font-weight: 900;
}

.audit-header-date {
   justify-content: start;
}

@media (max-width: 767px) {

   .audit-menu-tab .nav-link {
      width: auto;
      height: auto;
   }

   .activity-log-button,
   .activity-log {
      display: none;
   }

}

@media (max-width: 575px) {
   .audit-header {
      flex-direction: column-reverse;
   }

   .audit-header-date {
      justify-content: center;
   }

}

.editor {
   display: flex;
}

.toolbar {
   /* Toolbar styles */
   display: flex;
   flex-direction: column;
}

.content {
   /* Content area styles */
   margin-left: 20px;
}

.cover-page {
   /* Cover page styles */
   width: 500px;
   height: 300px;
   border: 1px solid #ccc;
   position: relative;
}

.cover-image {
   /* Cover image styles */
   width: 100%;
   height: 100%;
   object-fit: cover;
}

.logo {
   /* Logo styles */
   position: absolute;
   top: 10px;
   left: 10px;
}

.cover-text {
   /* Cover text styles */
   position: absolute;
   bottom: 10px;
   left: 10px;
   color: white;
}

.details {
   /* Details section styles */
   margin-top: 20px;
}

.detail-item {
   /* Detail item styles */
   margin-bottom: 10px;
}

.block-button-container {
   display: flex;
   margin-left: -3px;
   gap: 3px;
}

@media (min-width: 1900px) {

   /* Adjust breakpoint as needed */
   .block-button-container {
      gap: 6px;
      /* Larger gap for larger screens */
   }
}

.collapsible-content {
   padding: 10px;
   margin-top: 10px;
   overflow: hidden;
   transition: width 0.3s ease;
   float: right;
   /* Float the element to the right */
}

.collapse-transition {
   transition: width 0.3s ease;
}
</style>